export default {
  categories: {
  shoes: 'Chaussures',
  hoodies: 'Sweats/Hoodies',
  tshirts: 'T-Shirts',
  jackets: 'Vestes',
  pants: 'Pantalons/Shorts',
  headwear: 'Couvre-chefs',
  sets: 'Ensembles',
  underwear: 'Sous-vêtements',
  jersey: 'Maillots',
  accessories: 'Accessoires',
  bags: 'Sacs',
  belts: 'Ceintures',
  perfumes: 'Parfums',
  other: 'Autres articles',
  },
};